import { IGetState, TCardId } from '../../../../../../../../../types/types';
import { Dispatch, ThunkAction } from '../../../../../../../../../types/actions';
import { cardsActionSetAction } from '../../../../../../../../../store/model/actions/cardsActionSetAction';
import { cardsUpdateAction } from '../../../../../../../../../store/model/cards/actions/cardsUpdateAction';
import { getCard } from '../../../../../../../../../store/model/selectors/getCard';

export const onToggleQuickLookCollapse = (
    cardId: TCardId,
): ThunkAction => {
    return (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        const { isQuickLookCollapse } = getCard(getState(), cardId);
        dispatch(cardsActionSetAction(cardsUpdateAction({ [cardId]: { isQuickLookCollapse: !isQuickLookCollapse } })));
    };
};
